import React from "react";
import { withRouter } from "react-router";

import "../css/Logo.scss";

class Logo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			logoAnimated: false,
			fullWidth: false
		};

		this.props.history.listen((location, action) => {
			const currentLocation = location.pathname.replace("/", "").toLowerCase();

			if (!this.state.logoAnimated && currentLocation === "industry") {
				this.setState({
					logoAnimated: true
				});
			}
			if (!this.state.fullWidth && currentLocation === "generating") {
				this.setState({
					fullWidth: true
				});
			}
		});
	}

	render() {
		return (
			<div
				className={
					"wizard-sidebar-header " +
					(this.state.logoAnimated ? " animate" : "") +
					(this.state.fullWidth ? " fullWidth" : "")
				}>
				<div
					className={
						"wizard-sidebar-logo " + (this.state.logoAnimated ? "animate" : "")
					}>
					<img src={"./images/loyalty-gen-logo.svg"} alt="Logo" />
				</div>
			</div>
		);
	}
}

export default withRouter(Logo);
